import { BlockedContactsPage } from './blocked-contacts/BlockedContactsPage'
import { LoyaltyProgramPage } from './loyalty-program/LoyaltyProgramPage'
import { MarketingCustomersPage } from './marketing-customers/MarketingCustomersPage'

/**
 * `manager-customers` — the customer browser and the loyalty programme.
 *
 * Ported: marketing-customers, and `/loyalty-program`'s settings tab. The campaigns tab
 * is the next unit of work — `FRONTEND-STATUS.md` carries its scope.
 *
 * **This module's buttons reach real people.** `/marketing-customers` sends e-mail, SMS
 * and web push to the 2 464 customers in the restored data. `BLOCKED.md` records that two
 * of those three paths have no local black hole — `SmsGateway.ENDPOINT` is a hard-coded
 * BulkGate URL with working credentials in the dump, and `WebPushGateway` posts to the 114
 * endpoints stored on real subscriptions. Nothing here may be exercised against the local
 * backend without intercepting the write.
 */
export const managerCustomersModule = {
  name: 'manager-customers',
  routes: [
    {
      path: '/marketing-customers',
      page: 'marketing-customers',
      // Legacy gates this on `loyalty_program`, not on a permission of its own:
      // `hasPermission("loyalty_program") && <Route path="/marketing-customers" …>`. Kept, because
      // changing who can see 2 464 customers' contact details is not a porting decision.
      guard: { permission: 'loyalty_program' },
      component: MarketingCustomersPage,
    },
    {
      // §9.787, owner O140 - the blocklist: blocked phones, e-mails and IP addresses. On the right every one of its
      // endpoints asks (BACKEND.md §10A.439).
      path: '/blocked-contacts',
      page: 'blocked-contacts',
      guard: { permission: 'marketing_customers_deactivate' },
      component: BlockedContactsPage,
    },
    {
      path: '/loyalty-program',
      page: 'loyalty-program',
      guard: { permission: 'loyalty_program' },
      component: LoyaltyProgramPage,
    },
  ],
} as const

export { BlockedContactsPage, LoyaltyProgramPage, MarketingCustomersPage }
